import toast from "react-hot-toast";

// The server's own explanation when there is one ("Your access does not allow
// this action"), not axios's "Request failed with status code 403".
export const errorMessage = (error, fallback = "Something went wrong") => {
  const serverMessage = error?.response?.data?.message;
  if (typeof serverMessage === "string" && serverMessage) return serverMessage;
  if (error?.response) return fallback;
  if (error?.message === "Network Error") {
    return "Cannot reach the server, please check your connection";
  }
  return error?.message || fallback;
};

// Background loads share one notice, so a server outage shows a single
// message instead of one per list.
export const loadFailed = (error) =>
  toast.error(errorMessage(error, "Some system data could not be loaded"), {
    id: "load-failed",
  });
